import { Flex, Text, Spacer, Box } from "@chakra-ui/react";
import CardRegra from "../CardRegra";
import OutlineButton from "components/Button/OutlineButton";
import { Control, useFieldArray, UseFormWatch } from "react-hook-form";
import Field from "components/Input/Field";
import { useRef, useState } from "react";
import { NotificacaoConfiguracaoForm } from "features/robo-cobranca/typings";
import ModalTemplateEmail from "./../ModalTemplateEmail/index";
import { IconButton } from "@chakra-ui/button";
import { FaEdit } from "react-icons/fa";
import colors from "core/resources/theme/colors";

function CardRegrasVencimento({
  titulo,
  tituloCard,
  renderAddButton = true,
  control,
  parentIndex,
  watch,
  tipoNotificacaoId,
  isInvalid,
}: {
  titulo: string;
  tituloCard: string;
  onChange?: (value: any) => any;
  renderAddButton?: boolean;
  control: Control<NotificacaoConfiguracaoForm>;
  parentIndex: number;
  watch: UseFormWatch<NotificacaoConfiguracaoForm>;
  tipoNotificacaoId: string;
  isInvalid?: boolean;
}) {
  const [isOpenModalTemplate, setIsOpenModalTemplate] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  const { append, remove } = useFieldArray({
    control,
    name: `tipos.${parentIndex}.items`,
  });

  return (
    <Flex
      borderColor={isInvalid ? colors.red : "transparent"}
      borderWidth="2px"
      borderRadius="8px"
      backgroundColor="#EBECF0"
      width="100%"
      height="355px"
      padding="12px"
      pt="8px"
      flexDir="column"
    >
      <Flex mb="8px" justifyContent="space-between">
        <Text fontSize="16px" fontWeight="500" fontFamily="Poppins">
          {titulo}
        </Text>

        <IconButton
          bg="none"
          display="inline"
          minWidth={"unset"}
          height={"unset"}
          aria-label="Editar template de email"
          title="Editar template de email"
          icon={
            <FaEdit
              size={24}
              color={isInvalid ? colors.red : undefined}
              className={isInvalid ? "shake-animation" : undefined}
            />
          }
          onClick={() => setIsOpenModalTemplate(true)}
        />
      </Flex>
      <Flex gap="16px" width="100%" flexDir="column" overflowY="auto" ref={ref}>
        {watch(`tipos.${parentIndex}.items`)?.map((v: any, index: number) => (
          <Box
            borderRadius="8px"
            backgroundColor="#FFFFFF"
            px="10px"
            py="8px"
            w="100%"
          >
            <Field
              control={control}
              name={`tipos.${parentIndex}.items.${index}.dias`}
              rules={{
                required: !!renderAddButton,
              }}
              render={({ field, isInvalid }) => (
                <CardRegra
                  onDelete={() => remove(index)}
                  tituloCard={tituloCard}
                  temValor={renderAddButton}
                  onChange={(v) => {
                    field.onChange(v);
                  }}
                  valor={field.value}
                  isInvalid={isInvalid}
                />
              )}
            />
          </Box>
        ))}
      </Flex>
      <Spacer />
      {renderAddButton ||
      (!renderAddButton && !watch(`tipos.${parentIndex}.items`)?.length) ? (
        <Flex justifyContent="center" width="100%" mt={2}>
          <OutlineButton
            backgroundColor="#EBECF0"
            width="100%"
            onClick={() => {
              append({ dias: null });

              setTimeout(() => {
                ref.current?.scrollTo({
                  top: ref.current.scrollHeight,
                  behavior: "smooth",
                });
              }, 300);
            }}
          >
            Adicionar regra
          </OutlineButton>
        </Flex>
      ) : null}

      <ModalTemplateEmail
        isOpen={isOpenModalTemplate}
        onClose={() => setIsOpenModalTemplate(false)}
        control={control}
        parentIndex={parentIndex}
        tipoNotificacaoId={tipoNotificacaoId}
        titulo={titulo}
        watch={watch}
      />
    </Flex>
  );
}

export default CardRegrasVencimento;
